import { createContext } from 'react';
import { CreateTask } from 'shared/types/task';
import { Timestamp } from 'shared/types/timestamp';

export type CreateMultipleTasksDialogContextProps = {
  onOpenDialog: (
    taskNames: string[],
    onSubmit: (tasks: CreateTask[]) => Promise<void> | void,
    options?: {
      date?: Timestamp;
      context?: CreateTask;
      onCancel?: () => void;
    },
  ) => void;
};

export const CreateMultipleTasksDialogContext =
  createContext<CreateMultipleTasksDialogContextProps>({
    onOpenDialog: () => {},
  });
